import { useTranslation } from "react-i18next"
import { ContainerItemCard } from "./ContainerItemCard"
import { AddItemSelector } from "./AddItemSelector"

export const ContainerDiagram = ({
    containerType,
    items,
    editingIndex,
    storeId,
    availableTemplates,
    headerContent,
    onStartEdit,
    onUpdateItem,
    onRemoveItem,
    onDoneEdit,
    onAddItem,
}) => {
    const { i18n } = useTranslation()

    const isGroup = containerType === 'GROUP_CONTAINER'
    const borderColor = isGroup ? 'border-purple-500' : 'border-blue-500'
    const bgColor = isGroup ? 'bg-purple-50' : 'bg-blue-50'
    const labelBg = isGroup ? 'bg-purple-600' : 'bg-blue-600'
    const labelText = isGroup
        ? i18n.t('container_templates.container_types.GROUP_CONTAINER')
        : i18n.t('container_templates.container_types.PRODUCT_CONTAINER')

    // Calculate total pieces
    const totalPieces = items.reduce((sum, item) => {
        if (item.child_template_id || item.type === 'sub_container') {
            return sum
        }
        return sum + (item.quantity || 0) * (item.units_per_container || 0)
    }, 0)

    return (
        <div className={`${borderColor} rounded-xl p-5 ${bgColor} relative`} style={{ borderWidth: '3px', borderStyle: 'solid' }}>
            {/* Container label */}
            <div className={`absolute -top-3 left-4 ${labelBg} text-white px-3 py-0.5 rounded-full text-xs font-bold`}>
                {isGroup ? '\uD83C\uDFD7\uFE0F' : '\uD83D\uDCE6'} {labelText}
            </div>

            {/* Header fields */}
            {headerContent && (
                <div className="mt-2 mb-2">
                    {headerContent}
                </div>
            )}

            {/* Items row */}
            <div className="flex flex-wrap gap-3 items-start">
                {items.map((item, index) => (
                    <div
                        key={item._clientId ?? index}
                        className={editingIndex !== null && editingIndex !== index ? 'opacity-50' : ''}
                    >
                        <ContainerItemCard
                            item={item}
                            index={index}
                            storeId={storeId}
                            isEditing={editingIndex === index}
                            onStartEdit={onStartEdit}
                            onUpdate={onUpdateItem}
                            onRemove={onRemoveItem}
                            onDone={onDoneEdit}
                            availableTemplates={availableTemplates}
                        />
                    </div>
                ))}
                {editingIndex === null && (
                    <AddItemSelector onSelect={onAddItem} />
                )}
            </div>

            {/* Total bar */}
            {items.length > 0 && (
                <div className="mt-3 p-2 bg-green-50 rounded-lg text-center font-bold text-green-800 text-sm border border-green-200">
                    {i18n.t('container_templates.editor.total_bar', { count: totalPieces.toLocaleString() })}
                </div>
            )}
        </div>
    )
}
